import React, { useEffect, useState } from 'react';
import { Container, Box, Typography, Tabs, Tab, Grid, Paper, Button } from '@mui/material';
import { connect, useDispatch } from 'react-redux';
import { migrateOldCartData } from '@utilities/common';
import { useNavigate } from "react-router-dom";
import { getRestaurants } from '@utilities/auth';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import {clearCacheData} from '@utilities/common';
import FolderDeleteIcon from '@mui/icons-material/FolderDelete';
import { ConfirmationModal } from '@components/ConfirmModal//Confirmation';
import UserManagement from '@flows/Admin/UserManagement';
import RestaurantManagement from '@flows/Admin/RestaurantManagement';
import KOTPrinterSettings from './KOTPrinterSettings';
import BrandingSettings from './BrandingSettings';
import OnlineOrderSettings from './OnlineOrderSettings';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const UserProfile: React.FC = ({selectedRestaurant, roles, userInfo, isSuperAdmin}: any) => {
    const [tabValue, setTabValue] = useState(0);
    const [migrateBtnDisable, setMigrateBtnDisable] = useState(true);
    const [open, setOpen] = React.useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    useEffect(() => {
        var cartDataTemp = JSON.parse(localStorage.getItem(`cartData`) ?? '{}');
        if(selectedRestaurant?.tabs) {
            Object.entries(selectedRestaurant?.tabs).forEach(([key, val]:any) => {
                if(!!+val) {
                    new Array(+val).fill('1').forEach((val1: any, val2: any) => {
                        // var t1 = cartDataTemp[`${key}-${val2+1}`];
                        if(`${key}-${val2+1}` in cartDataTemp){
                            setMigrateBtnDisable(false);
                        }
                    });
                }
            });
        }
    }, [selectedRestaurant]);

    return (
        <>
            <Container maxWidth="md" sx={{ p: 0, my: 3 }} style={{minHeight: "calc(100vh - 172px)"}}>
                <Paper elevation={3} sx={{ p: 0 }}>
                    {/* User Info Section */}
                    <Box display="flex" alignItems="center" sx={{overflow: "hidden"}}>
                        {/* <Avatar
                            sx={{ width: 80, height: 80, mr: 3 }}
                            src={userInfo?.image || "https://cdn.pixabay.com/photo/2020/07/01/12/58/icon-5359553_640.png"}
                            alt="User Avatar"
                        /> */}
                        <AccountBoxIcon color="secondary" sx={{fontSize: '5rem'}} />
                        <Box>
                            <Typography variant="h5" component="div">
                                {userInfo?.name}
                            </Typography>
                            <Typography className='textBreak' color="text.secondary">{userInfo?.email}</Typography>
                        </Box>
                    </Box>

                    {/* Tabs Section */}
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', p: 0 }}>
                        <Tabs value={tabValue} onChange={handleTabChange} aria-label="User Profile Tabs" variant="scrollable" scrollButtons="auto">
                            <Tab label="Settings" {...a11yProps(0)} />
                            <Tab label="KOT Printers" {...a11yProps(1)} />
                            <Tab label="Branding" {...a11yProps(2)} />
                            <Tab label="Online Orders" {...a11yProps(3)} />
                            {isSuperAdmin && <Tab disabled={!isSuperAdmin} label="Users" {...a11yProps(4)} />}
                            {isSuperAdmin && <Tab disabled={!isSuperAdmin} label="Restaurants" {...a11yProps(5)} />}
                            <Tab disabled label="Profile" {...a11yProps(6)} />
                            {/* {isSuperAdmin && <Tab disabled={!isSuperAdmin} label="Super Admin" {...a11yProps(2)} />} */}
                        </Tabs>
                    </Box>

                    {/* Tab Panels */}
                    <TabPanel value={tabValue} index={0}>
                        <Grid container spacing="space-between" direction="column" sx={{p: 0, gap: 1}}>
                            <Grid item>
                                <Button variant='outlined' color="primary" onClick={(_e) => {migrateOldCartData(selectedRestaurant); setMigrateBtnDisable(true);}} disabled={!!migrateBtnDisable}>
                                    <CloudSyncIcon /> &nbsp; Fix Cart Orders
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button variant='outlined' color="primary" onClick={(_e) => getRestaurants(dispatch, roles, { preserveSelectedRestId: selectedRestaurant?.docId })}>
                                    <DriveFileMoveIcon /> &nbsp; Sync Restaurant Data
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button variant='outlined' color="primary" onClick={()=>setOpen(true)}>
                                    <FolderDeleteIcon /> &nbsp; Clear Cache and Data
                                </Button>
                            </Grid>
                        </Grid>
                    </TabPanel>
                    <TabPanel value={tabValue} index={1}>
                        <KOTPrinterSettings />
                    </TabPanel>
                    <TabPanel value={tabValue} index={2}>
                        <BrandingSettings />
                    </TabPanel>
                    <TabPanel value={tabValue} index={3}>
                        <OnlineOrderSettings />
                    </TabPanel>
                    {isSuperAdmin && <TabPanel value={tabValue} index={4}>
                                <UserManagement />
                    </TabPanel>}
                    {isSuperAdmin && <TabPanel value={tabValue} index={5}>
                                <RestaurantManagement />
                    </TabPanel>}
                    <TabPanel value={tabValue} index={6}>
                        <Typography variant="h6">Profile Information</Typography>
                        <Typography>Here is the detailed information about the user profile.</Typography>
                    </TabPanel>
                </Paper>
            </Container>
            <ConfirmationModal
                open={open}
                title="Delete Expense"
                message={<Typography variant="body1">Are you sure you want to <span style={{color: '#fff', fontWeight: 'bold',backgroundColor: 'var(--secondary)', padding: '2px 5px'}}>delete saved Food Cart data</span>? This action cannot be undone.</Typography>}
                confirmLabel="Delete"
                onConfirm={() => clearCacheData(dispatch, navigate)}
                onCancel={()=>setOpen(false)}
                severity="error"
            />
      </>
    );
};

const mapStateToProps = (state: any) => {
    const { common, user } = state;
    return {
        selectedRestaurant: common?.selectedRestaurant,
        userInfo: {
            "name": user?.user?.name,
            "email": user?.user?.email,
            "img": user?.user?.image,
        },
        roles: user?.user?.roles,
        // userPermissions: user?.user?.roles ? {...common?.globalConfig?.permissions, ...(user?.user?.roles[common?.selectedRestaurant?.docId]?.permissions)} : {},
        isSuperAdmin: !!(user?.user?.isSuperAdmin)
    }
}

export default connect(mapStateToProps)(UserProfile)
